<template>
    <el-card class="box-card full-screen recharge-apply">
      <div ref="pageHead" class="table-page-head">
        <el-form :inline="true" :model="queryForm">
          
          <el-form-item :label="$t('checkStatus')">
            <el-select v-model="queryForm.status" :placeholder="$t('all')" size="small">
              <el-option :label="$t('all')" value=""></el-option>
              <el-option :label="$t('new')" value="0"></el-option>
              <el-option :label="$t('closed')" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="getList" :loading="isLoading"><i class="el-icon-search"></i> {{$t('query')}}</el-button>
          </el-form-item>
        </el-form>
        <el-row class="table-btns">
        <el-button type="text" size="mini" icon="el-icon-edit" @click="openAddIncident()">{{$t('add')}}</el-button> 
        
      </el-row>
      </div>
  
      <div class="data-table" v-if="loginInfo.orgType == 1" :style="{top:queryTableHeight,height:`calc(100% - ${queryTableHeight} - 70px)`}">
        <el-table :data="tableData.records" v-loading="isLoading" element-loading-background="rgba(255,255,255,0.4)" size="mini" height="100%">
          <el-table-column prop="id" :label="$t('ID')" width="50"></el-table-column>
          
          <el-table-column prop="amount" :label="$t('amount')" min-width="180" align="center">
            <template slot-scope="scope"><span class="franc">₣</span>{{Number(scope.row.amount).formatMoney(0)}}</template>
          </el-table-column>
          <el-table-column prop="reason" :label="$t('reason')" width="160"></el-table-column>
          <el-table-column prop="title" :label="$t('title')" width="160"></el-table-column>
          <el-table-column prop="incidentType" :label="$t('incidentType')" min-width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.incidentType==0" class="text-danger">{{$t('financial')}}</span>
              <span v-if="scope.row.incidentType==1" class="text-warning">{{$t('material')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="incidentDate" :label="$t('incidentDate')" min-width="160">
            <template slot-scope="scope">{{scope.row.incidentDate?$manba(scope.row.incidentDate).format('ymdhms'):""}}</template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('status')" min-width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.status==0" class="text-danger">{{$t('new')}}</span>
              <span v-if="scope.row.status==1" class="text-primary">{{$t('closed')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="comments" :label="$t('comments')" width="160"></el-table-column>
  
          <el-table-column prop="orgInfoId" :label="$t('orgId')" width="160"></el-table-column>
          

          <el-table-column prop="createTime" :label="$t('creationTime')" min-width="160">
            <template slot-scope="scope">{{scope.row.createTime?$manba(scope.row.createTime).format('ymdhms'):""}}</template>
          </el-table-column>

          <el-table-column :label="$t('extend')" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status==0" size="mini" @click="openCheckApply(scope.row)" type="primary">{{$t('check')}}</el-button>
              <el-button v-else size="mini" disabled>{{$t('check')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <el-pagination background layout="total,sizes,prev,pager,next,jumper" :total="tableData.total||0" :page-sizes="[20, 30, 50, 100, 200]" :page-size="pageSize" :current-page="currentPage" @size-change="setPageSzie" @current-change="setCurrentChange" @prev-click="setCurrentChange" @next-click="setCurrentChange" />
  
      <el-drawer :title="$t(applyTitle)" :visible.sync="isAddApply" :direction="'rtl'" :modal="false" :destroy-on-close="true" :wrapperClosable="false" :size="700">
      <el-form :model="addForm" :rules="rules" ref="addForm">

        <el-form-item :label="$t('amount')" prop="amount">
          <el-input size="medium" v-model="addForm.amount"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('reason')" prop="reason">
          <el-input size="medium" v-model="addForm.reason"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('title')" prop="title">
          <el-input size="medium" v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('incidentType')">
          <el-select v-model="addForm.incidentType" :placeholder="$t('all')" size="small">
            <el-option :label="$t('financial')" value="0"></el-option>
            <el-option :label="$t('material')" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('incidentDate')" prop="incidentDate">
             <el-date-picker v-model="addForm.incidentDate" type="datetime" :time-arrow-control="true"  :format="'yyyy-MM-dd HH:mm:ss'" :placeholder="$t('selectDateAndTime')" style="width:100%">
             </el-date-picker>
           </el-form-item>
        
        <el-form-item :label="$t('comments')" prop="comments">
          <el-input type="textarea" size="medium" v-model="addForm.comments"></el-input>
        </el-form-item>

        <div class="bottom-button">
          <el-button size="medium" type="primary" :loading="isLoading" @click="onSubmitAdd('addForm')">{{$t('submit')}}</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer :title="$t(applyTitle2)" :visible.sync="isCheckApply" :direction="'rtl'" :modal="false" :destroy-on-close="true" :wrapperClosable="false" :size="700">
      <el-form :model="checkForm" :rules="checkRules" ref="checkForm">
        <el-divider content-position="left">{{$t('applyInfo')}}</el-divider>
        <el-form-item :label="$t('reason')" prop="reason">
          <el-input size="medium" v-model="addForm.reason"  disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('title')" prop="title">
          <el-input size="medium" v-model="addForm.title" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('incidentType')" prop="incidentType">
          <el-input size="medium" v-model="addForm.incidentType" disabled></el-input>
        </el-form-item>


        <el-divider content-position="left">{{$t('checkInfo')}}</el-divider>
        <el-form-item :label="$t('checkStatus')" prop="status">
          <el-radio v-model="checkForm.status" :label="0" border>{{$t('new')}}</el-radio>
          <el-radio v-model="checkForm.status" :label="1" border>{{$t('closed')}}</el-radio>
        </el-form-item>
        
        <div class="bottom-button">
          <el-button size="medium" type="primary" :loading="isLoading" @click="onSubmitCheckResult('checkForm')">{{$t('submit')}}</el-button>
        </div>
      </el-form>
    </el-drawer>
      
    </el-card>
  </template>
  
  <script>
  
  import incident from '@/api/incident'
  import manba from '@/assets/uilt/manbaDate'

  export default {
    name: "incident",
    data () {
      return {
        isLoading: false,
        //table高度，动态设置
        queryTableHeight: String,
        //table显示内容
        tableData: {},
        //分页器默认参数
        pageSize: 20,
        currentPage: 1,
  
        queryForm: {},
        //是否显示审核申请弹框
        isCheckApply: false,
        applyTitle2: "Validation Incident",
        
        
        isAddApply: false,
        applyTitle: "Incident",
       
  
        //申请表单
        addForm: {},
        //审核表单
        checkForm: {},

      }
    },
    computed: {
      rules () {
        return {
          //amount: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
          reason: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
          title: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
          incidentType: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
          incidentDate: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],

            
        }
      },
      checkRules() {
    return {
      status: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }]
    }
  },
      loginInfo () { return this.$store.state.globalParameter.loginInfo; }
    },
    methods: {
      getList () {
        let _this = this;
        _this.isLoading = true;
        incident.getPage({
          param: { current: _this.currentPage, size: _this.pageSize, ..._this.queryForm },
          success: res => {
            _this.isLoading = false;
            _this.tableData = res.data || {};
          }
        })
      },
      setPageSzie (val) {
        this.pageSize = val;
        this.getList();
      },
      setCurrentChange (val) {
        this.currentPage = val;
        this.getList();
      },
      openAddIncident () {
      this.isAddApply = true; 
    },
      openCheckApply (row) {
        this.isCheckApply = true;
        this.addForm = row;
        this.checkForm = {
            id: row.id,
          status: row.status,  
        }
       
      },

      /**提交充值申请 */
    onSubmitAdd (refName) {
      let _this = this;
      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        _this[refName].incidentDate = manba(_this[refName].incidentDate).format('ymdhms')
        incident.addIncident({
          param: _this[refName],
          success: res => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t('operateSuccessfully'));
              _this.isAddApply = false;
              _this.getList();
            }
            else
              _this.$message.warning(_this.$t(res.msg));
              
          }
        })
      })

    },
  
      /**提交充值申请 */
      onSubmitCheckResult (refName) {
        let _this = this;
        this.$refs[refName].validate(valid => {
          if (!valid) return false;
          incident.disposeIncident({
            param: _this[refName],
            success: res => {
              _this.isLoading = false;
              if (res.code == 200) {
                _this.$message.success(_this.$t('operateSuccessfully'));
                _this.isCheckApply = false;
                _this.getList();
              }
              else
                _this.$message.warning(_this.$t(res.msg));
            }
          })
        })
      },

    },
    mounted () {
      let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
      this.queryTableHeight = queryTableHeight + 'px';

      this.getList();
    },
  }
  </script>
  
  <style lang="less" scoped>
  .recharge-apply {
    #org-info-from {
      .el-col-8 {
        margin-bottom: 31px;
      }
    }
  
    .testes {
      animation: identifier 300ms;
    }
    @keyframes identifier {
      0% {
        height: 0px;
      }
      100% {
        height: 100px;
      }
    }
  }
  </style>